import React from 'react';

const Button = ({ children, onClick, styles }) => {
    return (
        <button
            style={{ ...styles }}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

export default Button;